// removed by extract-text-webpack-plugin
module.exports = {"header":"src-components-MobileHeader----mobile-header-module---header---2nGU8","nav":"src-components-MobileHeader----mobile-header-module---nav---DahvL"};


//////////////////
// WEBPACK FOOTER
// ./src/components/MobileHeader/mobile-header.module.scss
// module id = 330
// module chunks = 168707334958949